import { createSelector } from 'reselect';

import { SnackbarSlice, name } from './reducer';

const getSnackbarState = (state: SnackbarSlice) => state[name];

export const notificationsSelector = createSelector(getSnackbarState, state => state.notifications);
